(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/models/login.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/models/login.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.models.Login = Backbone.Model.extend({
    defaults: {
      hideUsernameLogin: false,
      hideFrejaEidLogin: false,
      ssn: undefined,
      username: undefined,
      password: undefined,
      returnUrl: undefined,
      cancelUrl: undefined,
      autoStartToken: undefined,
      isStandardMobile: undefined,
      action: undefined,
      isCustomerRegistration: false,
      isSsnFallback: false,
      useragent_family: '',
      startBankId: false,
      returnNewCustomer: false,
      authRef: undefined,
      isTabletDevice: undefined,
      otherFrejaDevice: false,
      currentTab: 'bankid',
      hideInIosApp: false,
      isSsnLogin: false,
      sameDevice: true
    },
    initialize: function initialize() {
      var _this = this;

      var logger = svs.core.log.getLogger('module:player-login');
      svs.components.Storage.browser.get('ssn', 'customer_login', this.set.bind(this, 'ssn'));

      if (this.get('isCustomerRegistration')) {
        this.set('currentTab', 'bankid');
      } else {
        svs.core.deviceSession.get('currentLoginMethod', 'customer_login', function (result, err) {
          if (err) {
            logger.debug('Error when getting current login method from device session.');
          }

          _this.set('currentTab', !svs.core.detect.feature('ft-frejaid') && result === 'frejaeid' ? 'bankid' : result || 'bankid'); 


          if (_this.get('hideInIosApp') && _this.get('currentTab') === 'frejaeid') {
            _this.set('currentTab', 'bankid');
          }

          _this.set('currentTab', !svs.core.detect.feature('ft-frejaid') && result === 'frejaeid' ? 'bankid' : result || 'bankid');
        });
      }
    },
    toQueryString: function toQueryString(loginType) {
      var returnUrl = this.get('returnUrl') ? "returnUrl=".concat(encodeURIComponent(this.get('returnUrl'))) : '',
          cancelUrl = this.get('cancelUrl') ? "&cancelUrl=".concat(encodeURIComponent(this.get('cancelUrl'))) : '',
          ast = this.get('autoStartToken') ? "&ast=".concat(encodeURIComponent(this.get('autoStartToken'))) : '',
          authRef = this.get('authRef') ? "&authref=".concat(encodeURIComponent(this.get('authRef'))) : '',
          ofd = this.get('otherFrejaDevice') ? "&ofd=".concat(this.get('otherFrejaDevice')) : '',
          rnc = this.get('returnNewCustomer') ? '&rnc=true' : '';
      var queryString;

      if (loginType === 'bankid') {
        queryString = "".concat(returnUrl).concat(rnc).concat(cancelUrl).concat(ast);
      } else if (loginType === 'frejaeid') {
        queryString = "".concat(returnUrl).concat(ofd).concat(rnc).concat(cancelUrl).concat(authRef);
      } else {
        queryString = "".concat(returnUrl).concat(rnc).concat(cancelUrl);
      }

      queryString = queryString.indexOf('&') === 0 ? queryString.replace('&', '') : queryString;
      return queryString;
    }
  });
})(Backbone, _, svs);
 })(window);